import { render, staticRenderFns } from "./SupplierCriteriaForm.vue?vue&type=template&id=d4c2ab32&scoped=true&"
import script from "./SupplierCriteriaForm.vue?vue&type=script&lang=js&"
export * from "./SupplierCriteriaForm.vue?vue&type=script&lang=js&"
import style0 from "./SupplierCriteriaForm.vue?vue&type=style&index=0&id=d4c2ab32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c2ab32",
  null
  
)

export default component.exports